module.exports = __webpack_public_path__ + "img/kanae-minato.1c88a088.png";